import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL


export const sendWhatsAppMsgAPI = async (payload) => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };

    const response = await axios.post(`${apiBaseUrl}/superAdmin/send-whatsapp-message`, payload, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error WhatsApp Msg:", error);
    throw error;
  }
}